import * as api from './adapter';

export default {
  /**
   * getManagers
   * @returns {Promise<*>}
   */
  index: ({ pagination, sort, search }) => api.read('managers', {
    query: {
      sort: `${sort.direction === 'asc' ? '' : '-'}${sort.field}`,
      page: { size: pagination.itemsPerPage, number: pagination.current },
      filter: { title: search },
    },
  }),
  /**
   * show - get manager item
   * @param id
   * @returns {Promise}
   */
  show: (id) => api.read(`countries/${id}`),
  /**
   * createManager
   * @param attributes
   * @returns {Promise}
   */
  create: ({ title }) => api.create({
    type: 'countries',
    attributes: { title },
  }),
  /**
   * updateManager
   * @param id
   * @param attributes
   * @returns {Promise}
   */
  update: (id, attributes) => api.update({
    id,
    type: 'countries',
    attributes,
  }),
  /**
   * deleteManager
   * @returns {Promise<*>}
   */
  delete: (id) => api.destroy({ id, type: 'countries' }),
};
